(function () {
  'use strict';

  if (window.sgCardShippingStatus) return;

  var selector = '[data-sg-card-shipping-status]';
  var calendar = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  var monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  var messages;
  var previousDay;

  function today() {
    var values = {};
    calendar.formatToParts(new Date()).forEach(function (part) { values[part.type] = part.value; });
    return { year: Number(values.year), month: Number(values.month), day: Number(values.day) };
  }

  function ordinal(value) {
    return Date.UTC(value.year, value.month - 1, value.day) / 86400000;
  }

  function parseEta(raw) {
    var value = (raw || '').trim();
    var iso = /^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/.exec(value);
    var legacy = /^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun)\s+([A-Za-z]{3})\s+(\d{1,2})\s+(\d{4})(?:$|\s)/i.exec(value);
    var date;
    if (iso) {
      date = { year: Number(iso[1]), month: Number(iso[2]), day: Number(iso[3]) };
    } else if (legacy) {
      date = { year: Number(legacy[3]), month: monthNames.indexOf(legacy[1].toLowerCase()) + 1, day: Number(legacy[2]) };
    } else {
      return null;
    }
    if (date.year < 1000 || date.month < 1 || date.month > 12 || date.day < 1 || date.day > 31) return null;
    var check = new Date(ordinal(date) * 86400000);
    return check.getUTCFullYear() === date.year && check.getUTCMonth() + 1 === date.month && check.getUTCDate() === date.day ? date : null;
  }

  function setText(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  function update(element) {
    if (element.dataset.stockState !== 'preorder' || element.hidden) return;
    var eta = parseEta(element.dataset.eta);
    var current = today();
    var dateLabel = element.querySelector('[data-sg-eta-date]');
    var time = element.querySelector('[data-sg-eta-time]');
    var message = element.querySelector('[data-sg-eta-message]');
    if (!dateLabel || !time || !message) return;

    var showDate = eta !== null && ordinal(eta) >= ordinal(current);
    dateLabel.hidden = !showDate;
    message.hidden = showDate;
    if (!showDate) {
      setText(message, eta ? messages.updating : messages.pending);
      return;
    }

    var dateFormat = { timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric' };
    setText(time, new Intl.DateTimeFormat('en-NZ', dateFormat).format(new Date(ordinal(eta) * 86400000)));
    time.setAttribute('datetime', String(eta.year) + '-' + String(eta.month).padStart(2, '0') + '-' + String(eta.day).padStart(2, '0'));
  }

  function refresh(root) {
    root = root || document;
    if (root.nodeType === 1 && root.matches(selector)) update(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(update);
  }

  function init() {
    var translations = document.getElementById('SgCardShippingTranslations');
    if (!translations) return;
    try { messages = JSON.parse(translations.textContent); } catch (_error) { return; }
    window.sgCardShippingStatus = { refresh: refresh };
    previousDay = ordinal(today());
    refresh();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) { if (node.nodeType === 1) refresh(node); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(function () {
      var day = ordinal(today());
      if (day !== previousDay) {
        previousDay = day;
        refresh();
      }
    }, 60000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    window.addEventListener('pageshow', function () { refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
